import React from "react";

export const twitterShareLink = "https://twitter.com/intent/tweet?text=";
export const facebookShareLink =
  "https://www.facebook.com/dialog/feed?app_id=5656793821114956";
export const whatsappShareLink = "https://api.whatsapp.com/send?text=";
// export const WEB_BASE_URL = "https://www.narendramodi.in/selfiecampaignmahilalabharthi/detail/";
export const WEB_BASE_URL = "https://www.narendramodi.in/mbsmdl";


export const dataList = [
  {
    location: "कैंट",
    subLocations: [
      {
        name: "महामना",
        values: [
          "गंगोत्री बॉयज हॉस्टल नगवा",
          "ब्लिस गेस्ट हाउस",
          "सीमा यादव जी के आवास पर",
          "शीतला माता मंदिर नरिया",
          "सूरज जी के आवास पर",
          "लोलार्क कुंड",
          "कृष्णा पेइंग गेस्ट हाउस अस्सी",
          "हनुमान मदिर भेलूपुर",
          "गौडीया मठ सोनारपुरा",
          "शीतला माता मंदिर भेलूपुर",
          "सुमित पटेल जी का आवास",
          "सभापति भवन नरिया",
          "हनुमान घाट आश्रम",
          "लोलार्क कुंड",
          "सुरेश गुप्ता जी के आवास पर",
          "राम लीला मैदान खोजवा",
          "राजेश यादव जी के आवास पर",
          "आदर्श पुस्तकालय खोजवा",
          "शीतला माता मंदिर भेलूपुर",
          "श्री खोजवा रास्ट्रीय उच्चतर माध्यमिक विद्यालय खोजवा",
          "बड़ी गैबी व्यायाम शाला",
          "भारौतिया शक्ति माता मंदिर",
          "चिनात्मानी गणेश मंदिर सोनारपुरा",
        ],
      },
      {
        name: "रामनगर",
        values: [
          "संतोष श्रीवास्तव जी का आवास भगवानपुर",
          "शिव गंगा वाटिका भगवानपुर",
          "पंचायत भवन सुल्तानपुर",
          "श्रीराम एकेडमी रामपुर",
          "श्रीराम एकेडमी रामपुर",
          "श्री अंकित राय जी के आवास पर",
          "श्री लल्लन सोनकर जी के आवास पर",
          "श्याम मूर्ति द्विवेदी इंग्लिश स्कूल रामनगर",
          "श्रीमती निक्की सिंह के आवास पर",
          "गुफाबीर हनुमान मंदिर प्रांगण गोलाघाट",
          "श्री अमरेश कुशवाहा जी के आवास पर",
          "धर्मशाला बलुआघाट रामनगर",
          "उडिया घाट आश्रम साहित्यनाका रामनगर",
          "विमला कानवेंट स्कूल भीटी",
        ],
      },
      {
        name: "कैंट",
        values: [
          "जगन्नाथ मंदिर",
          "माता कुण्ड परिसर",
          "अभिषेक अग्रहरी जी आवास",
          "गंगाराम जी का आवास",
          "विजय विश्वकर्मा जी आवास",
          "मौर्य बाग नर्सरी",
          "प्राचीन हनुमान मंदिर सिध्द्गिरीबाग",
          "अग्रवाल कोचिग सेंटर",
          "सम्पुर्नानद नगर पार्क",
          "पंचायती मंदिर छित्त्तुपुर",
          "राजेश कुशवाहा जी का आवास",
          "पार्षद जी आवास",
          "नोंद्रा माता मंदिर",
          "बेचू महादेव मंदिर",
          "कनैह्या शर्मा जी आवास",
          "सिन्धु सोनकर पार्षद जी आवास",
          "पार्षद जी आवास",
          "भरत जयसवाल जी आवास",
          "पार्षद जी आवास",
          "कबीर मठ",
        ],
      },
      {
        name: "डॉ श्यामा प्रसाद मुखर्जी मण्डल",
        values: [
          "काली बाड़ी, सोनारपुरा",
          "राज गेस्ट हॉउस, हवेली",
          "दिशा स्कूल पाण्डेय घाट",
          "इंद्रा गाँधी बा० लि० अगस्तकुंडा",
          "रानी भवानी पाण्डेय घाट",
          "अमित पाण्डेय जी के आवास",
          "अगस्त मुनि मन्दिर",
          "अमित सौरभ जी के आवास",
          "विजय बीर हनुमान मन्दिर",
          "मातेश्वरी गेस्ट हॉउस",
          "शांति सिल्क हॉउस, रामापुरा",
          "रुक्मणीइंटर कालेज तुलसीपुर",
          "कन्या प्राइमरी एवं पूर्व मा० कन्या वि० शंकुधारा",
          "काशी हिन्दू वि०वि० शिक्षा संकाय कमच्छा",
          "रणवीर संस्कृत वि० कमच्छा",
          "हरी शंकर सिंह जी के आवास",
          "काली माता मन्दिर लक्ष्मीकुंड",
        ],
      },
      {
        name: "रविदास",
        values: [
          "ब्रिज बल्लभ तिवारी आवास",
          "पार्षद आवास",
          "सेक्टर संयोजक आवास",
          "धनञ्जय मौर्या आवास",
          "कविन्द्र नारायण आवास",
          "मुंशी प्रेमचंद पार्क",
          "सेक्टर संयोजक आवास",
          "सेक्टर संयोजक आवास",
          "ईश्वर वाटिका",
          "सेक्टर संयोजक आवास",
          "भिखारीपुर पोखरा",
          "अनिल सिंह आवास",
          "विनीत सिंह ,आवास",
          "अरविन्द पटेल आवास",
          "सुन्दरपुर पार्क",
          "हरिशंकर मिश्र आवास",
          "सेक्टर संयोजक आवास",
          "अरविन्द मौर्या ,आवास",
          "विक्रम सिंह आवास",
          "रत्नेश्वर मोदनवाल ,आवास",
          "जितेन्द्र पटेल आवास",
          "अब्दुल अव्वल का आवास",
          "विजय वर्मा आवास",
          "संतोष कन्नौजिया ,आवास",
          "राजकुमार प्रजापति आवास",
          "चंद्रकांत केसरी आवास",
          "प्रियंका मौर्या ,आवास",
          "सतीश राजभर आवास",
          "शशांक प्रजापति आवास",
          "श्याम आसरे आवास",
        ],
      },
      {
        name: "छावनी",
        values: ["हनुमान मंदिर", "शीतला मंदिर"],
      },
    ],
  },
  {
    location: "उत्तरी",
    subLocations: [
      {
        name: "धुपचंडी",
        values: [
          "राधा लॉन,चंद्रा चौराहा",
          "गुप्ता जी कटरा, सोनातालाब",
          "सावित्री लॉन, दनियालपुर",
          "सावित्री लॉन, दनियालपुर",
          "सावित्री लॉन, दनियालपुर",
          "साहिल हाउस, सोनातालाब",
          "चौरा माता मंदिर, सिंधवाघाट",
          "चौरा माता मंदिर, सिंधवाघाट",
          "विकास गुप्ता आवास, शैलपुत्री",
          "आनंद मौर्या आवास",
          "स्थर होम एनगलिश स्कूल",
          "स्थर होम एनगलिश स्कूल",
          "अजित विश्वकर्मा आवास",
          "धुपचंडी माता मंदिर",
          "शैलपुत्री माता मंदिर",
          "शैलपुत्री माता मंदिर",
          "शैलपुत्री माता मंदिर",
          "पंचायितीय हनुमान मंदिर, जलालीपुरा",
          "पंचायितीय हनुमान मंदिर, जलालीपुरा",
          "सतीश अग्रवाल आवास",
          "एस0पी0 कान्वेंट स्छोल सरैया",
          "एस0पी0 कान्वेंट स्छोल सरैया",
          "हामिदुल हसन का आवास",
          "सुभाष चौहान जी का दूकान बड़ी बाजार",
          "प्रमोद जायसवाल आवास",
          "शैलेन्द्र जायसवाल आवास",
          "शैलेन्द्र जायसवाल आवास",
          "सूर्य नारायण केशरी आवास",
          "त्रिभुवन जी आवास",
        ],
      },
      {
        name: "सारनाथ",
        values: [
          "हनुमान यादव के दुकान पर",
          "जगदीश त्रिपाठी का आवास",
          "मनोज अग्रहरि का आवास",
          "विद्यालय पर ही",
          "विद्यालय पर ही",
          "पार्षद कार्यालय",
          "अरविन्द जायसवाल के कार्यालय पर",
          "संदीप श्रीवास्तव पूर्व पार्षद का आवास",
          "नरेन्द्र पटेल के आवास पर",
          "राजेश यादव पार्षद का कार्यालय",
          "अजीत सिंह के कार्यालय (दुकान)",
          "संजय साहू के आवास पर",
          "पार्षद संजय जायसवाल का कार्यालय",
          "अतुल सिंह का आवास",
          "गणपत मंदिर स्थान",
          "सिद्धार्थ सिंह का आवास-महादेव नगर",
          "मीरा सिंह का आवास",
          "हरिशंकर सिंह का आवास",
          "जवाहर गुप्ता का आवास",
          "पूनम पाण्डेय का आवास",
          "अभय पाण्डेय पार्षद का आवास",
          "माला तिवारी का आवास",
          "राजेन्द्र मौर्या पार्षद का कार्यालय",
          "विनोद पाण्डेय का आवास",
          "दिनेश पाण्डेय का आवास",
          "रामवृक्ष पटेल का दुकान",
          "राम त्रिपाठी का आवास",
          "विनोद सिंह का आवास",
        ],
      },
      {
        name: "राजर्षि",
        values: [
          "पार्षद रोहित मिश्रा कार्यालय",
          "रामजानकी मंदिर",
          "एस0डी0 लॉन तरना",
          "शिवशंकर यादव आवास",
          "अनिल राय का आवास",
          "शशि भूषण आवास",
          "कुलदीप त्रिपाठी आवास",
          "मण्डल कार्यालय",
          "अमित मौर्या आवास",
          "अरविन्द सिंह आवास",
          "भूपेन्द्र सिंह आवास मण्डल मंत्री",
          "बनशक्ति मंदिर",
          "रामजानकी मंदिर शिवपुर",
          "उर्मिला सिंह आवास",
          "शमीम जी का आवास",
          "रामाकांत दुबे आवास",
          "अनुपम जी आवास",
          "प्रमोद प्रजापति आवास",
          "आर्य समाज मंदिर",
          "अरविन्द सिंह आवास",
          "मतदान केंद्र स्थल",
          "मतदान केंद्र स्थल",
          "अशोक मौर्या आवास",
          "गोविन्द कुमार आवास",
          "शैलेश गुप्ता आवास",
          "राजेन्द्र पटेल आवास",
          "मतदान केंद्र स्थल",
        ],
      },
      {
        name: "बागेश्वरी",
        values: [
          "राधेश्याम पब्लिक स्कूल ढेलवरिया चौकाघाट",
          "कंपोजिट विद्यालय अर्दली बाजार",
          "प्राथमिक कन्या विद्यालय तेलिया बाग",
          "संपूर्णानंद संस्कृत विश्वविद्यालय",
          "राजकीय बालिका इंटर कॉलेज इंग्लिशिया लाइन",
          "चंदुआवीर बाबा मंदिर के पास",
          "कैलगढ़ प्राथमिक विद्यालय",
          "भारतीय शिक्षा मंदिर इंटर कॉलेज इंग्लिशिया लाइन",
          "कटिंग मेमोरियल इंटर कॉलेज",
          "प्राथमिक विद्यालय लहरतारा",
          "प्राथमिक विद्यालय लहरतारा",
          "क्रिश्चियन प्राइमरी पाठशाला",
          "क्रिश्चियन प्राइमरी पाठशाला",
          "प्राथमिक विद्यालय रघुवीर तेलिया बाग",
          "एल टी कॉलेज मकबूल आलम रोड",
          "आकाश कुमार का निवास स्थान S H 19/2 सिकरौल",
          "शिवम सिंह का निवास स्थल सिकरौल वाराणसी",
          "नीरज जी का निवास स्थान ढिठौरी महाल अर्दली बाजार",
          "कमलापति इंटर कॉलेज",
          "प्राथमिक विद्यालय मलदहिया",
          "श्री विश्वकर्मा शिक्षा निकेतन स्कूल",
          "मंगल करण हनुमान मंदिर",
          "हरसेवा नंद स्कूल के पीछे",
        ],
      },
    ],
  },
  {
    location: "सेवापुरी",
    subLocations: [
      {
        name: "राजातालाब",
        values: [
          "श्री राजेन्द्र पाल के आवास पर",
          "श्री श्यामधर मिश्रा के आवास पर",
          "श्री रामधनी के आवास पर",
          "श्री अनिरूद्ध बिन्द के आवास पर",
          "श्री अच्छे लाल बिन्द के आवास पर",
          "श्री संतोष कुमार के आवास पर",
          "शिव मंदिर बंगला पर",
          "श्री नन्हे दूबे के आवास पर",
          "श्री शिव कुमार के आवास पर",
          "श्री आशुतोष उपाध्याय के आवास पर",
          "श्री सभाजीत पाण्डेय के आवास पर",
          "श्री जय प्रकाश के आवास पर",
          "श्री श्याम नारायण के आवास पर",
          "श्री निहाला मिश्रा के आवास पर",
          "श्री कैलाश पटेल के आवास पर",
          "श्री माता प्रसाद के आवास पर",
          "श्री अभिषेक मिश्रा के आवास पर",
          "श्री उज्ज्वल पाण्डेय के आवास पर",
          "श्री विमल कुमार सिंह के आवास पर",
          "पंचायत भवन पर",
          "श्री आशीष कुमार सिंह के आवास पर",
          "श्री जगत नारायण के आवास पर",
          "श्री शीतला पटेल के आवास पर",
          "श्री संजय कुमार यादव के आवास पर",
          "श्री राज कुमार के आवास पर",
          "श्री संजय पटेल के आवास पर",
          "श्री रोहित कुमार के आवास पर",
          "श्री तेजनाथ मौर्य के आवास पर",
          "श्री आनन्द श्रीवास्तव के आवास पर",
          "श्री विनय विश्वकर्मा के आवास पर",
          "श्री राजेन्द्र यादव के आवास पर",
          "श्री मंगला प्रसाद के आवास पर",
          "श्री मंगला प्रसाद के आवास पर",
          "श्री प्रकाश उपाध्याय के आवास पर",
          "श्री संदीप गुप्ता के आवास पर",
          "श्री अजय सिंह बबलू के आवास पर",
          "श्री सुजीत के आवास पर",
          "श्री रविन्द्र कुमार के आवास पर",
          "श्री परमेश्वर केशरी के आवास पर",
          "श्री योगेन्द्र नारायण सिंह के आवास पर",
          "श्री रामसिंह के आवास पर",
          "श्री जितेन्द्र पटेल के आवास पर",
          "श्री राजेश कुमार पटेल के आवास पर",
          "श्री महेन्द्र उपाध्याय के आवास पर",
          "श्री सुरेन्द्र सिंह के आवास पर",
          "श्री आजाद शेखर के आवास पर",
          "श्री आशीष कुमार के आवास पर",
          "श्री विनोद गुप्ता के आवास पर",
          "श्री धर्मेन्द्र प्रताप सिंह के आवास पर",
          "श्री दीपक जी के आवास पर",
          "पंचायत भवन पर",
          "श्री रमेश के आवास पर",
          "श्री कोमल सिंह के आवास पर",
          "पंचायत भवन पर",
        ],
      },
      {
        name: "जन्सा",
        values: [
          "श्री अंकुश मिश्रा के आवास पर",
          "श्री शम्भू के आवास पर",
          "श्री संजय वर्मा के आवास पर",
          "श्री अजय पटेल के आवास पर",
          "श्री महेन्द्र राजभर के आवास पर",
          "श्री सत्य नारायण के आवास पर",
          "श्री रामजी वर्मा के आवास पर",
          "श्री दिलीप बिन्द के आवास पर",
          "श्री दिनेश के आवास पर",
          "श्री भानू प्रताप के आवास पर",
          "श्री विवेक उपाध्याय के आवास पर",
          "श्री राजेश के आवास पर",
          "श्री कृष्ण कुमा वर्मा के आवास पर",
          "श्री सूरज वर्मा के आवास पर",
          "श्री विनय सिंह के आवास पर",
          "श्री विजय सिंह के आवास पर",
          "श्री अजय गुप्ता के आवास पर",
          "श्री यशवन्त सिंह के आवास पर",
          "श्री सूर्यबली के आवास पर",
          "श्री सुरेन्द्र पाण्डेय के आवास पर",
          "श्री रामचन्द्र के आवास पर",
          "श्री अनिल गर्ग के आवास पर",
          "श्रीमती विनीता सिंह के आवास पर",
          "श्री रामसकल पटेल के आवास पर",
          "श्री श्रीराम गुप्ता के आवास पर",
          "श्री प्रेम नारायण के आवास पर",
          "श्री बरसाती के आवास पर",
          "श्री जितेन्द्र सिंह के आवास पर",
          "श्री श्रीश दूबे के आवास पर",
          "श्री देवेन्द्र आजाद के आवास पर",
          "श्री मनीष दूबे के आवास पर",
          "श्री विजय के आवास पर",
          "श्री बिरजू प्रतापति के आवास पर",
          "श्री बैजनाथ मौर्य के आवास पर",
          "श्री सुशील सिंह तोयज के आवास पर",
        ],
      },
      {
        name: "सेवापुरी",
        values: [
          "राम जानकी मंदिर के पास",
          "कमला बिंद का घर",
          "जगदीश का घर",
          "बंटी सिंह का घर",
          "रामआसरे के घर के पास बगीचे में",
          "सुशील दुबे के घर के पास बगीचे में",
          "महेश मिश्रा के मशीन के पास",
          "राजकुमार के घर केपास",
          "लक्ष्मी दुबे के घर केपास",
          "लाल जी की दुकान के पास",
          "दुर्गा के घर केपास",
          "विनोद सिंह के घर के पास",
          "राकेश सिंह के घर के पास",
          "अखिलेश पांडे के घर के पास",
          "अवध के घर के पास",
          "विनोद पांडे के दुकान के पास",
          "चे मेमोरियल स्कूल",
          "हनुमान जी का मंदिर",
          "मनोज विश्वकर्मा का घर",
          "हनुमान जी का मंदिर",
          "तूफानी सिंह का आवास",
          "सूरज का घर",
          "आशीष का आवास",
          "हनुमान जी का मंदिर",
          "हनुमान जी का मंदिर",
          "हनुमान जी का मंदिर",
          "रिंकू का दुकान",
          "मनोज का आवास",
          "महेंद्र गौड़ का आवास",
          "प्रमोद प्रजापति का घर",
          "जयप्रकाश का घर",
          "धीरेंद्र सिंह का घर",
          "शंकर जी का मंदिर",
          "राज बहादुर का घर",
          "सुजीत राजभर का घर",
          "रामआसरे प्रधान का घर",
          "पंचायत भवन के पास",
          "त्रिभुवन पाण्डेय का घर",
          "अरविंद तिवारी का घर",
          "राम मिलन पाल का घर",
          "नारायण प्रजापति का घर",
        ],
      },
      {
        name: "मॉ कालिका धाम",
        values: [
          "श्री प्रशांत पटेल के आवास पर",
          "श्री सुजीत कुमार के आवास पर",
          "श्री राजकुमार के आवास पर",
          "श्री दिलीप के आवास पर",
          "श्री विरेन्द्र पटेल के आवास पर",
          "श्री आशीष चौहान के आवास पर",
          "श्री पुनीत पाठक के आवास पर",
          "सोनबरसा ग्राम प्रधान के आवास पर",
          "श्री सुशील सिंह के आवास पर",
          "बूथ अध्यक्ष श्याम सुन्दर के आवास पर",
          "श्री सुरेन्द्र प्रताप सिंह के कटरा पर",
          "श्री परशुराम मौर्या के आवास पर",
          "श्री मनोज सिंह के आवास पर",
          "श्री अजीत सिंह के आवास पर",
          "श्री विवेक जी के आवास पर",
          "ग्राम प्रधान रघुनाथपुर के आवास पर",
          "डॉ0 संजय दूबे के आवास पर",
          "श्री विनोद विश्वकर्मा के आवास पर",
          "बूथ अध्यक्ष संदीप पटेल के आवास पर",
          "श्री विरेन्द्र पटेल के आवास पर",
          "श्री ताड़कनाथ पाण्डेय के आवास पर",
          "श्री अवनीश मिश्रा के आवास पर",
          "ग्राम प्रधान पतिराजपुर के आवास पर",
          "श्री धीरेन्द्र मौर्या के आवास पर",
          "बूथ अध्यक्ष 144 के आवास पर",
          "श्री सुनील पाण्डेय के आवास पर",
          "ग्राम प्रधान रैसीपुर के आवास पर",
          "श्री चन्द्रदीप त्रिपाठी के आवास पर",
          "ग्राम प्रधान नोनखरा विरेन्द्र पाल के आवास पर",
          "श्री गिरीशचन्द्र वर्मा के आवास पर",
          "श्री सुबाषचन्द्र मौर्या के आवास पर",
          "श्री राजकुमार तिवारी के आवास पर",
          "श्री जोगेश कुमार पाण्डेय के आवास पर",
          "ग्राम प्रधान कुरसातो के आवास पर",
          "श्री विजय प्रताप के आवास पर",
          "श्री अनिल कुमार मिश्रा के आवास पर",
          "श्री रमेंश सरोज के आवास पर",
          "श्री अंकित पाण्डेय के आवास पर",
          "श्री सुधीर सिंह के आवास पर",
          "श्री शीतला पटेल के आवास पर",
          "श्री हुनमान जी मंदिर पर",
          "श्री सोमेन्द्र जी के आवास पर",
          "श्री दीपक मिश्रा के आवास पर",
          "बूथ अध्यक्ष के आवास पर",
          "बूथ अध्यक्ष के आवास पर",
          "श्री नीरज द्विवेदी के आवास पर",
        ],
      },
    ],
  },
  {
    location: "रोहनिया",
    subLocations: [
      {
        name: "कर्दमेश्वर",
        values: [
          "एम0जी0 मेमोरियल स्कूल, कंदवा",
          "एम0जी0 मेमोरियल स्कूल, कंदवा",
          "एम0जी0 मेमोरियल स्कूल, कंदवा",
          "रोशन लॉन, अवलेशपुर",
          "हनुमान मन्दिर, पोंगलपुर",
          "हीरालाल पब्लिक स्कूल, कंचनपुर",
          "हीरालाल पब्लिक स्कूल, कंचनपुर",
          "श्री सुरेश सिंह जी के आवास पर",
          "वर्टेवस पब्लिक स्कूल, नाथूपुर",
          "श्री कृष्ण कुमार जी के आवास पर",
          "डाफी बाबा जी का अखाड़ा",
          "ज्ञान गंगा चिल्ड्रेन स्कूल, छिŸापुर",
          "श्री सुनील सिंह का हाता",
          "श्री सुनील सिंह का हाता",
          "पार्षद कार्यालय",
          "होली चिल्ड्रेन स्कूल प्रांगण",
          "शक्ति केन्द्र संयोजक का आवास",
          "घूरेलाल मेमोरियल स्कूल, जलालीपट्टी",
          "करमनवीर के0पी0 पब्लिक स्कूल, सुसुवाही",
          "ओम लान सुसुवाही",
          "ओम लान सुसुवाही",
          "पार्षद आवास",
          "श्री हनुमान मन्दिर, चन्दन नगर, करौंदी",
          "रामचरन पब्लिक स्कूल, डोमरी",
          "सरस्वती शिक्षा निकेतन, सूजाबाद",
          "प्रकाश वाटिका, सूजाबाद",
          "प्रकाश वाटिका, सूजाबाद",
          "प्रकाश वाटिका, सूजाबाद",
        ],
      },
      {
        name: "शूलटंकेश्वर",
        values: [
          "श्री सिन्धु सिंह जी के आवास पर",
          "श्री सतीश गौतम जी के आवास पर",
          "श्री मुकुन्द लाल जायसवाल जी के आवास पर",
          "श्री मुकुन्द लाल जायसवाल जी के आवास पर",
          "श्री दिलीप जी के आवास पर",
          "श्री अनूप श्रीवास्तव जी के आवास पर",
          "श्री सुरेन्द्र नारायण सिंह जी के आवास पर",
          "श्री बब्बून सेठ जी के आवास पर",
          "श्री रूपनारायण जी के आवास पर",
          "श्री राजेश सिंह जी के आवास पर",
          "श्री विरेश्वर सिंह जी के आवास पर",
          "श्री मनोज सिंह जी के आवास पर",
          "श्री रमेश प्रधान जी के आवास पर",
          "श्री अमित सिंह जी के आवास पर",
          "श्री शिवप्रकाश जी के आवास पर",
          "श्री सुबाष जी के आवास पर",
          "श्री शिवपूजन जी के आवास पर",
          "श्री आशीष जी के आवास पर",
          "श्री विनोद जी के आवास पर",
          "श्री शिवपूजन जी के आवास पर",
          "श्री देशराज सिंह जी के आवास पर",
          "श्री अमरनाथ गिरी जी के आवास पर",
          "श्री आनन्द जी के आवास पर",
          "श्री अनिल जी के आवास पर",
          "श्री श्यामजी सिंह जी के आवास पर",
          "श्री सनानन्द जी के आवास पर",
          "श्री पप्पू राजभर जी के आवास पर",
          "श्री अरविन्द जी के आवास पर",
          "श्री अरविन्द जी के आवास पर",
          "श्री कैलाश प्रधान जी के आवास पर",
          "श्रीमती सुधा जी के आवास पर",
          "श्री विकास शर्मा जी के आवास पर",
          "श्री रामप्रसाद जी के आवास पर",
          "गजाधरपुर पंचायत भवन के पास",
          "श्री सुरेन्द्र राजभर जी के आवास पर",
          "श्री मुन्ना पटेज जी के आवास पर",
          "प्रधान जी के आवास पर",
          "श्री अवधेश जी के आवास पर",
          "श्री दिनेश यादव जी के आवास पर",
          "श्री सुबाष पटेल के आवास पर",
          "श्री सुबाष पटेल के आवास पर",
          "शिव मन्दिर पयागपुर",
          "चौरा माता मन्दिर",
          "श्री अविनाश जी के आवास पर",
          "श्री चन्दन जी के आवास पर",
          "श्री सौरभ पटेल जी के आवास पर",
          "श्री माल्यवंत जी के आवास पर",
          "श्री धर्मेन्द्र जी के आवास पर",
          "श्री अरूण जी के आवास पर",
          "श्री रमेश बिन्द सत्या जी के आवास पर",
          "श्री विजय बिन्द जी के आवास पर",
          "श्री रामखेलावन जी के आवास पर",
          "श्री विवेक दूबे जी के आवास पर",
          "पद्मावती डिग्री कॉलेज",
        ],
      },
      {
        name: "रामेश्वर",
        values: [
          "श्री राम नारायण सिंह जी के आवास पर",
          "श्री सौरभ सिंह जी के आवास पर",
          "श्री त्रिभुवन मौर्या जी के आवास पर",
          "श्री जयप्रकाश यादव जी के आवास पर",
          "श्री अवनी सिंह जी के आवास पर",
          "श्री सुनील सिंह जी के आवास पर",
          "श्री आशीष पटेल जी के आवास पर",
          "श्री धीरज त्रिपाठी जी के आवास पर",
          "श्री कालीनाथ सरोज जी के आवास पर",
          "श्री महेन्द्र प्रसाद जी के आवास पर",
          "श्री जयप्रकाश सिंह जी के आवास पर",
          "श्री आनन्द सिंह जी के आवास पर",
          "श्री मनीष श्रीवास्तव जी के आवास पर",
          "श्री सुमन कुमार पाण्डेय जी के आवास पर",
          "श्री राहुल यादव जी के आवास पर",
          "श्री संदीप कुमार पटेल जी के आवास पर",
          "श्री आशीष यादव जी के आवास पर",
          "श्री मुनीब पटेल जी के आवास पर",
          "डॉ0 अजय सिंह जी के आवास पर",
          "श्री दिलीप शर्मा जी के आवास पर",
          "श्री संकठा राजभर जी के आवास पर",
          "श्री रामधनी प्रजापति जी के आवास पर",
          "श्री धर्मराज पटेल जी के आवास पर",
          "श्री धर्मेन्द्र सिंह जी के आवास पर",
          "श्री विजय जायसवाल जी के आवास पर",
          "श्री मनोज सिंह जी के आवास पर",
          "श्री जंगबहादुर पटेल जी के आवास पर",
          "श्री अवनीश उपाध्याय जी के आवास पर",
          "श्री आलोक पाण्डेय जी के आवास पर",
          "श्री धर्मेन्द्र मौर्या जी के आवास पर",
          "श्री संतोष मिश्रा जी के आवास पर",
          "श्री शिवशंकर पटेल जी के आवास पर",
          "श्री रिंकू सिंह जी के आवास पर",
          "श्री अवध नारायण मौर्य जी के आवास पर",
          "श्री मनोज पाण्डेय जी के आवास पर",
          "श्री महेन्द्र पटेल जी के आवास पर",
          "श्री दुर्गेश पाठक जी के आवास पर",
          "श्री नितिन पाण्डेय जी के आवास पर",
          "श्री सिन्धु प्रकाश वर्मा जी के आवास पर",
          "श्री मन्नू उपाध्याय जी के आवास पर",
          "श्री बुलन्दे राजभर जी के आवास पर",
          "श्री रमेश पटेल जी के आवास पर",
          "श्री नीरज श्रीवास्तव जी के आवास पर",
          "श्री भानुशंकर पटेल जी के आवास पर",
          "श्री संतोष गुप्ता जी के आवास पर",
          "श्री अरविन्द पाण्डेय जी के आवास पर",
          "श्री राजेश राजभर जी के आवास पर",
          "श्री मनोज मिश्रा जी के आवास पर",
          "श्री विरेन्द्र सिंह पटेल जी के आवास पर",
          "श्री भोला राजभर जी के आवास पर",
          "श्री विपिन पटेल प्रधान जी के आवास पर",
          "श्री विजय मौर्या जी के आवास पर",
          "श्री दिनेश शर्मा जी के आवास पर",
          "श्री कुबेर चन्द्र गुप्ता जी के आवास पर",
          "श्री जयप्रकाश गुप्ता जी के आवास पर",
          "श्री सत्यम सेठ जी के आवास पर",
        ],
      },
      {
        name: "रोहनिया",
        values: [
          "बाड़ासुर मन्दिर",
          "श्री विपिन पटेल जी के आवास पर",
          "श्री बबलू मौर्या जी के आवास पर",
          "श्री उदयभान सिंह जी के आवास पर",
          "श्री प्रदीप प्रजापति जी के आवास पर",
          "श्री राजेश पटेल ‘खन्ना’ जी के आवास पर",
          "श्री हेमेन्द्र सिंह जी के आवास पर",
          "श्री विनित सिंह जी के आवास पर",
          "श्री दीपक परिहार जी के आवास पर",
          "श्री प्यारेलाल जी के आवास पर",
          "श्री उत्कर्ष पाण्डेय जी के आवास पर",
          "श्री शिवानन्द राजभर जी के आवास पर",
          "श्री अनिल सेठ जी के आवास पर",
          "श्री रविन्द्र सोनकर जी के आवास पर",
          "श्री श्यामले शर्मा जी के आवास पर",
          "श्री रामदुलार सिंह जी के आवास पर",
          "श्री विनय सिंह जी के आवास पर",
          "श्री संजय पाण्डेय जी के आवास पर",
          "श्री रमेश मौर्या जी के आवास पर",
          "श्री अजय पाल जी के आवास पर",
          "श्री पुनवासी पटेल जी के आवास पर",
          "श्री रामजी शास्त्री जी के आवास पर",
          "श्री संतलाल जी के आवास पर",
          "श्री रमाशंकर गुप्ता जी के आवास पर",
          "श्री रमेश गुप्ता जी के आवास पर",
          "श्री सुरेश गिरी जी के आवास पर",
          "श्री सदा पटेल जी के आवास पर",
          "श्री मनीष जायसवाल जी के आवास पर",
          "श्री ऋषु सिंह चन्देल जी के आवास पर",
          "श्री दिनेश चन्देल जी के आवास पर",
          "श्री महेन्द्र पटेल जी के आवास पर",
          "श्री प्रमोद कन्नौजिया जी के आवास पर",
          "श्री गणेश सिंह जी के आवास पर",
          "श्री विजय पटेल जी के आवास पर",
          "श्री अजयभान जी के आवास पर",
          "श्री प्रमोद पटेल जी के आवास पर",
          "श्री धर्मेन्द्र सिंह जी के आवास पर",
          "श्री शुभम चौबे जी के आवास पर",
          "श्री संजय पटेल जी के आवास पर",
          "श्री विरेन्द्र सिंह जी के आवास पर",
          "श्री विकाश मिश्रा जी के आवास पर",
          "श्री राकेश राजभर जी के आवास पर",
          "श्री प्रभात कुमार सिंह जी के आवास पर",
          "श्री राजेश कन्नौजिया जी के आवास पर",
        ],
      },
    ],
  },
  {
    location: "दक्षिणी",
    subLocations: [
      {
        name: "पंडीत दीनदयाल उपाध्याय",
        values: [
          "मुन्ना जी का आवास",
          "विनायक जी का आवास",
          "शक्ति माता मंदिर",
          "अनमोल वाटिका",
          "मशाराम पाठक",
          "मशाराम पाठक",
          "अनुपम जी का आवास",
          "गीता जी का आवास",
          "चिल्ड्रेन वर्ल्ड स्कूल",
          "समाधान पार्क",
          "शकील भाई का आवास",
          "जगदम्बा त्रिपाठी जी का आवास",
          "विवेक जी का आवास",
          "राकेश जी का आवास",
          "मुरारी श्रीवास्तव जी का आवास",
          "भईया लाल जी का आवास",
          "राजेश जी का आवास",
          "आर के मिश्रा जी का आवास",
          "मनिश जी का आवास",
          "अमिताभ जी का आवास",
          "अमित जी का आवास",
          "अभिषेक जी का आवास",
          "विकाश जी का आवास",
          "यस मौर्य का आवास",
          "राधा कृष्ण मंदिर",
        ],
      },
      {
        name: "मध्यमेश्वर",
        values: [
          "शम्भु माता मन्दिर",
          "पब्लिक स्कूल",
          "महादेव मन्दिर",
          "शाहकटरा",
          "माँ काली मन्दिर",
          "ज्वररेश्वर महादेव",
          "महाकालेश्वर मन्दिर",
          "डिगीया बाबा",
          "पातालपुरी मठ",
          "नवापुरा उधान",
          "गोरखनाथ मन्दिर",
          "यादव भवन",
          "मन्दाकनीमाता मन्दिर",
          "नागनाथ मन्दिर",
          "बलुआबीर मन्दिर",
          "रितुराज जी घर",
          "साहू निवास",
          "निवास इकबाल",
          "डिहबाबा मन्दिर",
          "राम जानकी मन्दिर",
          "चौरसिया कटरा",
          "ताराचंद बाडा सुडिया",
          "दुर्गा माता मन्दिर",
          "आजादपार्क",
          "निवास रहमान",
        ],
      },
      {
        name: "काशी विश्वनाथ",
        values: [
          "आनंद कानन भवन, टेढ़ी नीम",
          "रमेश तिवारी आवास",
          "आशुतोष त्रिपाठी आवास",
          "साईन फोर्ड अकैडमी",
          "विवेकानंद कसेरा आवास",
          "राममंदिर नेपाली खपड़ा",
          "भद्रकाली मंदिर",
          "विनायक गेस्ट हाउस",
          "आशुतोष अग्रवाल आवास",
          "नेपाली धर्मशाला",
          "कनकलता मिश्रा आवास",
          "रोहित पाठक आवास",
          "लक्ष्मी मंदिर गायघाट",
          "मोहन लाल केवट आवास",
          "रामबाबू आवास",
          "बिनय गुप्ता आवास",
          "अभिजीत भारद्वाज आवास",
          "अशोक चौबे आवास",
          "विष्णु यादव आवास",
          "राजेश सिंह आवास",
          "सनी रस्तोगी आवास",
          "अवनीश कुशवाहा आवास",
          "दिलीप कुशवाहा आवास",
          "बाला जी राय आवास",
          "सुनील सोनकर आवास",
          "शुभम चौरसिया आवास",
          "साहेब लाल आवास",
          "रवि सोनकर आवास",
          "अमजद हुसैन आवास",
          "शंकर साहू आवास",
          "संजय आवास",
          "मनोज यादव आवास",
          "रोशन गुजराती आवास",
        ],
      },
    ],
  },
];

export const parseURLParams = (url) => {
  var queryStart = url.indexOf("?") + 1,
    queryEnd = url.indexOf("#") + 1 || url.length + 1,
    query = url.slice(queryStart, queryEnd - 1),
    pairs = query.replace(/\+/g, " ").split("&"),
    parms = {},
    i,
    n,
    v,
    nv;

  if (query === url || query === "") return;

  for (i = 0; i < pairs.length; i++) {
    nv = pairs[i].split("=", 2);
    n = decodeURIComponent(nv[0]);
    v = decodeURIComponent(nv[1]);

    if (!parms.hasOwnProperty(n)) parms[n] = [];
    parms[n].push(nv.length === 2 ? v : null);
  }
  return parms;
};


export const checkMobile = () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    return "mobile";
  } else {
    return "desktop";
  }
};
export const appShareTextString = (text) => {
  // text = text ? text.split("'").join("") : "";
  text = text ? text.split("‘").join("'") : "";
  text = text ? text.split("’").join("'") : "";
  text = text ? text.split("‟").join('"') : "";
  text = text ? text.split("“").join('"') : "";
  text = text ? text.split("❝").join('"') : "";
  text = text ? text.split("❞").join('"') : "";
  text = text ? text.split("”").join('"') : "";
  text = text ? text.split("„").join('"') : "";
  return text;
};